<script lang="ts">
    import type { MenuActionItem, MenuSubItem } from "./index";
    import { onMount } from "svelte";

    export let item: MenuSubItem;
    export let active: number;

    function execute(item: MenuActionItem) {
        return () => {
            item.action();
            active = -1;
        };
    }

    const { enabled } = item as MenuActionItem;

    $: disabled = (enabled && $enabled == false) || false;
</script>

<!----------------------------------------------------------------------------->

{#if item.type === "sep"}
    <hr />
{:else if item.type === "group"}
    <div class="subitem group">
        <div class="name" class:disabled>
            {#if item.left}
                <svelte:component this={item.left.component} {...item.left.props} />
            {/if}
            <span>{item.name}</span>
            {#if item.right}
                <svelte:component this={item.right.component} {...item.right.props} />
            {/if}
        </div>

        <div class="dropdown">
            {#each item.items as subitem}
                <svelte:self item={subitem} bind:active />
            {/each}
        </div>
    </div>
{:else}
    <button class="subitem name" on:click={execute(item)} class:disabled {disabled}>
        {#if item.left}
            <svelte:component this={item.left.component} {...item.left.props} />
        {/if}
        <span>{item.name}</span>
        {#if item.right}
            <svelte:component this={item.right.component} {...item.right.props} />
        {/if}
    </button>
{/if}

<!----------------------------------------------------------------------------->

<style>
    hr {
        all: unset;
        border-bottom: 1px solid var(--gap-color-hard);
    }

    .subitem {
        all: unset;
        display: block;
        padding-inline: 1em;
        position: relative;
    }

    .subitem .dropdown {
        display: none;
        left: calc(100% - 4px);
        top: 3px;
    }

    .subitem:hover {
        z-index: 1;
        background-color: var(--button-hover);
    }

    .subitem:hover > .dropdown {
        display: flex;
        z-index: 1;
    }

    .name {
        display: flex;
        align-items: center;
        height: 2em;
    }

    .name span {
        margin-right: 2em;
    }

    .name span + :global(*) {
        margin-left: auto;
    }

    .name.disabled {
        color: var(--t-disabled);
        background-color: unset;
    }
</style>
